import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import {
    BackgroundColorDirective,
    ColorDirective,
    ListSwitchContainerDirective,
    ListSwitchDirective,
    TypographyDirective,
} from '@dartcounter/ui';
import { TranslateModule } from '@ngx-translate/core';
import { SlideDialogLayoutComponent } from 'src/app/shared/dialogs/slide-dialog-layout/slide-dialog-layout.component';
import { ModalService } from 'src/app/shared/services/modal.service';

import { OmniStateService } from '../../services/omni-state.service';

@Component({
    selector: 'app-omni-calibration-images',
    standalone: true,
    imports: [
        TranslateModule,
        SlideDialogLayoutComponent,
        BackgroundColorDirective,
        TypographyDirective,
        ColorDirective,
        ListSwitchContainerDirective,
        ListSwitchDirective,
    ],
    templateUrl: './omni-calibration-images.component.html',
    styleUrl: './omni-calibration-images.component.css',
})
export class OmniCalibrationImagesComponent {
    private timestamp = new Date().getTime();

    private modalService: ModalService = inject(ModalService);
    private omniStateService: OmniStateService = inject(OmniStateService);

    public cameras: Signal<{ name: string }[]> = computed(() => {
        return [0, 1, 2, 3].map((index) => ({
            name: this.cameraTitles[index],
        }));
    });

    public currentCameraImages: Signal<{ default: string; calibration: string }> = computed(() => {
        const ip = this.omniStateService.currentSmartDevice().ip_address;
        const camId = this.selectedCamera() + 1;

        return {
            calibration: `http://${ip}:8080/images/img_calib_frontview_${camId}.png?ts=${this.timestamp}`,
            default: `http://${ip}:8080/images/img_calib_preview_${camId}.png?ts=${this.timestamp}`,
        };
    });

    public selectedCamera: WritableSignal<number> = signal(0);

    private cameraTitles: string[] = [
        $localize`:@@TOP_LEFT:Top left`,
        $localize`:@@TOP_RIGHT:Top right`,
        $localize`:@@BOTTOM_RIGHT:Bottom right`,
        $localize`:@@BOTTOM_LEFT:Bottom left`,
    ];

    public changeView(camera: number): void {
        this.selectedCamera.set(camera);
    }

    public dismiss(): void {
        this.modalService.dismiss();
    }
}
